import { useContext } from 'react'
import { LanguageContext } from '../../contexts/language'
import './Footer.css'

const Footer = () => {
  const { t } = useContext(LanguageContext)

  return (
    <footer className='footer'>{t.madeWith}</footer>
  )
}

export default Footer
